import {
  PaginationContainer,
  PaginationInfo,
  PaginationControls,
  PageNavigationButton,
  PageButton,
} from "../styles/Layoutstyle";

const Pagination = ({ pagination, isMobile, onPageChange, getPageNumbers, isDarkMode }) => {
  if (!pagination || pagination.totalPages <= 0) return null;

  return (
    <PaginationContainer isDarkMode={isDarkMode}>
      <PaginationInfo isDarkMode={isDarkMode}>
        Showing {(pagination.page - 1) * pagination.pageSize + 1} to{" "}
        {Math.min(pagination.page * pagination.pageSize, pagination.total)} of{" "}
        {pagination.total} orders
      </PaginationInfo>

      <PaginationControls>
        <PageNavigationButton
          onClick={() => onPageChange(1)}
          disabled={pagination.page === 1}
          isDarkMode={isDarkMode}
        >
          {isMobile ? "<<" : "First"}
        </PageNavigationButton>

        <PageNavigationButton
          onClick={() => onPageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          isDarkMode={isDarkMode}
        >
          {isMobile ? "<" : "Previous"}
        </PageNavigationButton>

        {getPageNumbers()?.map((pageNum, index) =>
          pageNum === "..." ? (
            <span key={`ellipsis-${index}`}>...</span>
          ) : (
            <PageButton
              key={pageNum}
              active={pageNum === pagination.page}
              onClick={() => onPageChange(pageNum)}
              isDarkMode={isDarkMode}
            >
              {pageNum}
            </PageButton>
          )
        )}

        <PageNavigationButton
          onClick={() => onPageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          isDarkMode={isDarkMode}
        >
          {isMobile ? ">" : "Next"}
        </PageNavigationButton>

        <PageNavigationButton
          onClick={() => onPageChange(pagination.totalPages)}
          disabled={pagination.page === pagination.totalPages}
          isDarkMode={isDarkMode}
        >
          {isMobile ? ">>" : "Last"}
        </PageNavigationButton>
      </PaginationControls>
    </PaginationContainer>
  );
};

export default Pagination;
